import styled from "@emotion/styled";
import { ExpandMoreOutlined, Favorite, MoreVertRounded } from "@mui/icons-material";
import { Avatar, Card, CardActions, CardContent, CardHeader, Chip, Collapse, IconButton, ListItem, Stack, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import { useMemo, useState } from "react";

import { dateToRelativeDateFormat } from "../helpers/dateHelper";
import { nameToLeadingCharacters } from "../helpers/stringHelpers";
import { PostQuestionAnswer } from "../types/postQuestionAnswer";
import { RatingAnswerVisualizer } from "./answerTypes/ratingAnswerVisualization";
import { TextAnswerVisualizer } from "./answerTypes/textAnswerVisualizer";

const ExpandMore = styled((props: any) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));


interface PostListItemProps {
    creatorName: string;
    creationDate: Date;
    answers: PostQuestionAnswer[];
}

export default function PostListItem(props: PostListItemProps) {
    const chips = [
        <Chip label="Schiss" color="info" variant="outlined"/>,
        <Chip label="Gekotzt" color="error" />,
    ]

    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const answers = useMemo(() => {
        const copy = [...props.answers];
        return copy.sort((answerA, answerB) => {
            if (answerA.postQuestion.id < answerB.postQuestion.id) {
                return -1;
              }

              return 1;
        }
            ).map((answer) => {
            if (answer.postQuestion.questionType === "TEXT") return<TextAnswerVisualizer answer={answer} />
            if (answer.postQuestion.questionType === "RATING") return<RatingAnswerVisualizer answer={answer} />
        })
    }, [props.answers]);

    return (
        <ListItem alignItems="flex-start">
            <Card sx={{ maxWidth: 345, minWidth: 345 }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                            {nameToLeadingCharacters(props.creatorName)}
                        </Avatar>
                    }
                    action={
                        false && <IconButton aria-label="settings">
                            <MoreVertRounded />
                        </IconButton>
                    }
                    title={props.creatorName}
                    subheader={dateToRelativeDateFormat(props.creationDate)}
                />
                <CardContent>
                    {answers}
                    { false && (() => {
                            return <Stack direction="row" spacing={1}>{chips}</Stack>
                        })() } 
                </CardContent>
                <CardActions disableSpacing>
                    {false && <IconButton aria-label="add to favorites">
                        <Favorite />
                    </IconButton>}

                    {false && <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreOutlined />
                    </ExpandMore>}
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography paragraph>Method:</Typography>
                        <Typography paragraph>
                            Heat 1/2 cup of the broth in a pot until simmering, add saffron and set
                            aside for 10 minutes.
                        </Typography>
                        <Typography paragraph>
                            Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over
                            medium-high heat. Add chicken, shrimp and chorizo, and cook, stirring
                            occasionally until lightly browned, 6 to 8 minutes. Transfer shrimp to a
                            large plate and set aside, leaving chicken and chorizo in the pan. Add
                            pimentón, bay leaves, garlic, tomatoes, onion, salt and pepper, and cook,
                            stirring often until thickened and fragrant, about 10 minutes. Add
                            saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
                        </Typography>
                        <Typography paragraph>
                            Add rice and stir very gently to distribute. Top with artichokes and
                            peppers, and cook without stirring, until most of the liquid is absorbed,
                            15 to 18 minutes. Reduce heat to medium-low, add reserved shrimp and
                            mussels, tucking them down into the rice, and cook again without
                            stirring, until mussels have opened and rice is just tender, 5 to 7
                            minutes more. (Discard any mussels that don’t open.)
                        </Typography>
                        <Typography>
                            Set aside off of the heat to let rest for 10 minutes, and then serve.
                        </Typography>
                    </CardContent>
                </Collapse>
                </Card>
        </ListItem>
    )
}
